// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 369) return "static/chunks/369-bea48b3e8de648a7.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1082":"27fa06d68c4e3da9","3073":"42cf9ed7a38de7d1","5598":"4c58a66c99666f1c","7349":"d0332b1baf03bec4"}[chunkId] + ".js";
};